import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';



@Injectable({
  providedIn: 'root'
})

export class PurchaseOrders {

  private baseUrl = environment.apiPurchaseUrl;
  
  constructor( private http: HttpClient ) {}

  async addPreorder(providedId: string, presignedUrl: string): Promise<Observable<any>>{
    const url = `${this.baseUrl}ordenes/`;
    const params = new HttpParams().set('id_proveedor', providedId).set('url_presigned', presignedUrl);

    return this.http.post<any>(url, null, {params});
  }

  listPreordersByProvider(providerId: string): Observable<any>{
    const url = `${this.baseUrl}ordenes/`;
    return this.http.get<any>(url);
  }

  listPendingPreorders(): Observable<any> {
    const url = `${this.baseUrl}ordenes/`;
    return this.http.get<any>(url);
  }

  authirizeOrCancelPreorder(preorderId: string, action: number): Observable<any> {
    const url = `${this.baseUrl}ordenes/${preorderId}/${action}`;
    return this.http.patch<any>(url, {});
  }
}
